"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDropdownButton = void 0;
var _DropdownButton = require("./DropdownButton");
// TODO: in v9, move styled() from DropdownButton.jsx to here
var StyledDropdownButton = _DropdownButton.DropdownButton;
exports.StyledDropdownButton = StyledDropdownButton;